<template>
  <!-- NAVIGATION BAR -->
  <header class="l_header">
    <nav :class="['nav bd_grid', language === 'cn' ? 'font-cn' : 'font-en']">
      <div class="logo">
        <img src="../assets/img/Logo.jpg" alt="Company's logo" class="nav_logo_image">
        <router-link to="/" class="nav_logo">{{ content.nav_name }}</router-link>
      </div>
      <div class="nav_menu">
        <div v-show="!mobile" class="nav_list">
          <li class="nav_item"><router-link to="/" class="nav_link">{{ content.nav_home_title }}</router-link></li>
          <li class="nav_item">
            <div class="dropdown_menu">
              <router-link to="/industryArea" class="nav_link">{{ content.nav_industry_area_title }}</router-link>
              <div :class="['column', language]">
                <router-link
                  v-for="(area, index) in content.nav_industry_area"
                  :key="index"
                  :to="area.link"
                  class="nav_link"
                >
                  {{ area.title }}
                </router-link>
              </div>
              <div class="dropdown_background"></div>
            </div>
          </li>
          <li class="nav_item"><router-link to="/planAndCases" class="nav_link">{{ content.plan_and_cases_title }}</router-link></li>
          <li class="nav_item"><router-link to="/news" class="nav_link">{{ content.news_title }}</router-link></li>
          <li class="nav_item"><router-link to="/aboutUs" class="nav_link">{{ content.about_us_title }}</router-link></li>
          <!-- <li class="nav_item"><router-link to="/contactUs" class="nav_link">{{ content.contact_us_title }}</router-link></li> -->
          <div class="wechat">
            <img src="../assets/img/Wechat.png" alt="Wechat" class="wechat_image">
            <div class="dropdown_wechat_image">
              <img src="../assets/img/Wechat_qrcode.png" alt="QR code" class="nav_qrcode_image">
            </div>
          </div>
          <div class="bilibili">
            <a href="https://space.bilibili.com/3546607905671227">
              <img src="../assets/img/Bilibili.png" alt="Bilibili" class="bilibili_image">
              <div class="dropdown_bilibili_image">
                <img src="../assets/img/Bilibili_qrcode.jpg" alt="QR code" class="nav_qrcode_image">
              </div>
            </a>
          </div>
          <div class="language-switcher">
            <button type="button" @click="changeLanguage('cn')" :class="{ active: language === 'cn' }">中文</button>
            <button type="button" @click="changeLanguage('en')" :class="{ active: language === 'en' }">EN</button>
          </div>
        </div>

        <div class="burger_icon" @click="handleBurgerClick">
          <i v-show="icon_button" class="fas fa-bars" :class="{ 'icon_active': mobileNav }"></i>
        </div>

        <transition name="mobile-nav">
          <div v-show="mobileNav" class="sidebar">
            <div class="sidebar_backdrop" @click="handleXClick"></div>
            <ul class="dropdown_nav_list">
              <div class="sidebar_header">
                <img src="../assets/img/Logo.jpg" alt="Logo" class="sidebar_logo">
                <button type="button" class="close_button" @click="handleXClick" aria-label="Close menu">
                  <i class="fas fa-times"></i>
                </button>
              </div>
              <div class="items">
                <li class="nav_item"><router-link to="/" class="nav_link">{{ content.nav_home_title }}</router-link></li>
                <li class="nav_item">
                  <div class="dropdown_menu_item" :class="{ 'active-dropdown': isDropdownOpen }" @click="toggleDropdown">
                    <span>{{ content.nav_industry_area_title }}</span>
                    <i class="fas fa-chevron-down chevron" :class="{ 'chevron-open': isDropdownOpen }"></i>
                  </div>
                  <div v-if="isDropdownOpen" class="dropdown_submenu">
                    <div v-for="(area, index) in content.nav_industry_area" :key="index" class="dropdown_submenu_item">
                      <router-link :to="area.link" class="nav_link">{{ area.title }}</router-link>
                    </div>
                  </div>
                </li>
                <li class="nav_item"><router-link to="/planAndCases" class="nav_link">{{ content.plan_and_cases_title }}</router-link></li>
                <li class="nav_item"><router-link to="/news" class="nav_link">{{ content.news_title }}</router-link></li>
                <li class="nav_item"><router-link to="/aboutUs" class="nav_link">{{ content.about_us_title }}</router-link></li>
              </div>
              <div class="sidebar_lang">
                <div class="language-switcher">
                  <button @click="changeLanguage('cn')" :class="{ active: language === 'cn' }">中文</button>
                  <button @click="changeLanguage('en')" :class="{ active: language === 'en' }">EN</button>
                </div>
              </div>
            </ul>
          </div>
        </transition>
      </div>
    </nav>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex';
import { ref } from 'vue';
import en from '@/data/navbar_en.js';
import cn from '@/data/navbar_cn.js';

export default {
  name: 'AppHeader',
  setup() {
    const isDropdownOpen = ref(false);

    function toggleDropdown() {
      isDropdownOpen.value = !isDropdownOpen.value;
    }

    return {
      isDropdownOpen,
      toggleDropdown,
    };
  },
  data() {
    return {
      mobile: false,
      icon_button: false,
      mobileNav: false,
      windowWidth: null,
    };
  },
  mixins: [en, cn],
  computed: {
    ...mapState(['language']),
    content() {
      const defaultContent = { title: '', industry_areas: [] };
      const currentLanguage = this.language === 'en' ? this.en : this.cn;
      return currentLanguage || defaultContent;
    },
  },
  methods: {
    ...mapMutations(['setLanguage']),
    changeLanguage(lang) {
      this.setLanguage(lang);
    },
    handleBurgerClick(event) {
      event.preventDefault();
      this.toggleMobileNav();
      this.updateArrowSwitch(false);
      document.body.classList.toggle('no-scroll', this.mobileNav);
    },
    handleXClick(event) {
      event.preventDefault();
      this.toggleMobileNav();
      this.updateArrowSwitch(true);
      document.body.classList.toggle('no-scroll', this.mobileNav);
    },
    toggleMobileNav() {
      this.mobileNav = !this.mobileNav;
      this.icon_button = !this.icon_button;
    },
    updateArrowSwitch(state) {
      this.$router.push({ query: { arrowSwitch: state.toString() } });
    },
    checkScreen() {
      this.windowWidth = window.innerWidth;
      if (this.windowWidth <= 1518) {
        this.mobile = true;
        this.icon_button = true;
      } else {
        this.mobile = false;
        this.icon_button = false;
        this.mobileNav = false;
      }
    },
    handleResize() {
      this.checkScreen();
    },
  },
  mounted() {
    this.checkScreen();
    window.addEventListener('resize', this.handleResize);
  },
  beforeUnmount() {
    window.removeEventListener('resize', this.handleResize);
  },
};
</script>